/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect, useRef } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';

import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Radio, Button, Box } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import services from '../Service';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { Autocomplete } from '@mui/material';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { makeStyles } from '@material-ui/styles';

import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';

import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';

var screenCode = "PRODUCTDEMANDSUPPLY"

export default function ProductDemandSupply(props) {

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [route, setRoute] = useState([]);
    const [farmer, setFarmer] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [isActive, setIsActive] = useState(1);
    const [farmerwiseList, setFarmerwiseList] = useState([]);
    const [cropwiseList, setCropwiseList] = useState([]);

    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());

    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });
    const classes = useStyles();

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const onKeyDown = (e) => {
        e.preventDefault();
    };


    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        farmerID: "0",
        cropCategoryID: "0",
        cropID: "0",
        isActive: true,
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
    });

    const demandSupplySchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number().min(1, 'Please Select Operation Entity').required('Operation Entity Required'),
        farmerID: isActive == 1 ? Yup.number().min(1, 'Please Select Farmer').required('Farmer Required') : Yup.number().notRequired(),
        cropCategoryID: isActive == 0 ? Yup.number().min(1, 'Please Select Crop Category').required('Crop Category Required') : Yup.number().notRequired(),
        cropID: isActive == 0 ? Yup.number().min(1, 'Please Select Crop').required('Crop Required') : Yup.number().notRequired(),
        toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            farmerID: formData.farmerID,
            cropCategoryID: formData.cropCategoryID,
            cropID: formData.cropID,
            isActive: formData.isActive,
            fromDate: formData.fromDate,
            toDate: formData.toDate
        },
        validationSchema: demandSupplySchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'PRODUCTDEMANDSUPPLY');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }

    const [selectedSearchValuesFarmerwise, setSelectedSearchValuesFarmerwise] = useState({
        groupID: '',
        operationEntityID: '',
        farmerID: '',
        toDate: '',
        fromDate: ''
    });

    const [selectedSearchValuesCropwise, setSelectedSearchValuesCropwise] = useState({
        groupID: '',
        operationEntityID: '',
        farmerID: '',
        toDate: '',
        fromDate: ''
    });

    async function SubmitForm() {
        if (isActive == 1 || isActive == '1') {
            setCropwiseList([]);
            let res = await services.GetDemandSuplyFarmerwise(
                formik.values.operationEntityID,
                formik.values.farmerID,
                (fromDate).toISOString(),
                (toDate).toISOString(),
            );
            setFarmerwiseList(res);
            createDataForExcelCropwise(res);
            getSelectedDropdownValuesForReportFarmerwise();
        } else {
            setFarmerwiseList([])
            let res = await services.GetDemandSuplyCropwise(
                formik.values.operationEntityID,
                formik.values.cropID,
                (fromDate).toISOString(),
                (toDate).toISOString(),
            );
            setCropwiseList(res);
            createDataForExcelFarmerwise(res);
            getSelectedDropdownValuesForReportCropwise();
        }
    }

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(GetProductCategoties());
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetRouteByFactoryID());
        trackPromise(GetFarmerDetailsByFactoryIDRouteID());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        trackPromise(GetFarmerDetailsByFactoryIDRouteID());
    }, [formik.values.collectionCenterID]);

    useEffect(() => {
        trackPromise(GetAllProductVarietyByProductID());
    }, [formik.values.cropID]);

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            setProductcatogery(res);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(formik.values.operationEntityID, formik.values.cropCategoryID)
        if (res != null) {
            setProduct(res);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            setFactory(res);
        }
    }

    async function GetRouteByFactoryID() {
        var res = await services.GetRouteByFactoryID(formik.values.operationEntityID)
        if (res != null) {
            setRoute(res);
        }
    }

    async function GetFarmerDetailsByFactoryIDRouteID() {
        var res = await services.GetFarmerDetailsByFactoryIDRouteID(formik.values.operationEntityID)
        if (res != null) {
            setFarmer(res);
        }
    }

    async function GetAllProductVarietyByProductID() {
        var res = await services.GetAllProductVarietyByProductID(formik.values.cropID);
        if (res != null) {
            setProductVarietyList(res);
        }
    }

    const handleRadioChange = (event) => {
        setIsActive(event.target.value);
        setCropwiseList([]);
        setFarmerwiseList([]);
    };


    function handleSearch(data, e) {

        if (data === undefined || data === null) {
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            var valueV = data["farmerID"];

            setValues({
                ...values,
                farmerID: valueV.toString()
            });
        }
    }

    function clearAll() {
        formik.resetForm();
        setFarmerwiseList([]);
        setCropwiseList([]);
        setIsActive(1);
        setFromDate(new Date());
        setToDate(new Date());
        setFarmer([]);
    }

    async function createFileFarmerwise() {
        var file = await createDataForExcelFarmerwise(farmerwiseList);
        var settings = {
            sheetName: ' Product Demand and Supply Report (Farmerwise)',
            fileName: 'Product DS (Farmerwise)',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }
    async function createFileCropwise() {
        var file = await createDataForExcelCropwise(cropwiseList);
        var settings = {
            sheetName: 'Product Demand and Supply Report (Cropwise)',
            fileName: 'Product DS (Productwise)',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Outlet Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }
    async function createDataForExcelFarmerwise(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Farmer Name': x.firstName,
                    'Date': x.date.split('T')[0],
                    'Product': x.productName,
                    'Demanded Quantity': x.demandedQuantity,
                    'Supplied Quantity': x.suppliedQuantity
                }
                res.push(vr);
            });
        }
        return res;
    }

    async function createDataForExcelCropwise(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Farmer Name	': x.firstName,
                    'Date': x.date.split('T')[0],
                    'Product': x.productName,
                    'Demanded Quantity': x.demandedQuantity,
                    'Supplied Quantity': x.suppliedQuantity
                }
                res.push(vr);
            });
            return res;
        }
    }

    function getSelectedDropdownValuesForReportFarmerwise() {
        let groups = group.find(x => x.groupID == formik.values.groupID)
        let factories = factory.find(x => x.factoryID == formik.values.operationEntityID)
        let farmer = farmer.find(x => x.farmerID == formik.values.farmerID)

        setSelectedSearchValuesFarmerwise({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: factories.factoryName,
            farmer: farmer.firstName,
            fromDate: formik.values.fromDate,
            toDate: formik.values.toDate
        });
    }

    function getSelectedDropdownValuesForReportCropwise() {
        let groups = group.find(x => x.groupID == formik.values.groupID)
        let factorys = factory.find(x => x.factoryID == formik.values.operationEntityID)
        let products = product.find(x => x.cropID == formik.values.cropID)

        setSelectedSearchValuesCropwise({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: factorys.factoryName,
            cropID: products.productName,
            fromDate: formik.values.fromDate,
            toDate: formik.values.toDate
        });
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Product Demand Supply |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/createCropForcast"}
                        btname="Add"
                        pageName="Product Demand Supply"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Operation Entity *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.operationEntityID}

                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Operation Entity</MenuItem>
                                        {factory.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Start Date"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}

                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}

                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select End Date"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}

                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />}


                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                    <FormControlLabel
                                        style={{ width: '190px' }}
                                        control={
                                            <Radio
                                                color="secondary"
                                                checked={isActive == 1}
                                                onChange={handleRadioChange}
                                                value={1}
                                                name="radio-button-demo"
                                                inputProps={{ 'aria-label': 'true' }}
                                            />}
                                        label="Farmer wise"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        style={{ width: '180px' }}
                                        control={
                                            <Radio
                                                color="secondary"
                                                checked={isActive == 0}
                                                onChange={handleRadioChange}
                                                value={0}
                                                name="radio-button-demo"
                                                inputProps={{ 'aria-label': 'false' }}
                                            />}
                                        label="Crop wise"
                                        labelPlacement="end"
                                    />
                                    {isActive == 1 ?
                                        <Autocomplete fullWidth
                                            id="farmerID"
                                            options={farmer}
                                            getOptionLabel={(option) => option.givenName != null ? option.givenName.toString() : null}
                                            onChange={(e, value) => handleSearch(value, e)}
                                            defaultValue={null}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    variant="outlined"
                                                    name="farmerID"
                                                    label="Farmer *"
                                                    size="small"
                                                    fullWidth
                                                    style={{ width: '375px' }}
                                                    value={formik.values.farmerID}
                                                    getOptionDisabled={true}
                                                    helperText={touched.farmerID && errors.farmerID}
                                                    error={Boolean(touched.farmerID && errors.farmerID)}
                                                />
                                            }
                                        />
                                        : null}
                                    {isActive == 0 ?
                                        <TextField
                                            select
                                            fullWidth
                                            style={{ width: '375px' }}
                                            size="small"
                                            label="Crop Category *"
                                            value={formik.values.cropCategoryID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('cropCategoryID')}
                                            error={Boolean(touched.cropCategoryID && errors.cropCategoryID)}
                                            helperText={touched.cropCategoryID && errors.cropCategoryID}
                                        >
                                            <MenuItem key={0} value={0}> Select Crop Category</MenuItem>
                                            {productcatogery.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                                                    {option.productCategoryName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField> : null}
                                    {isActive == 0 ?
                                        <TextField
                                            select
                                            fullWidth
                                            style={{ width: '375px' }}
                                            size="small"
                                            label="Crop *"
                                            value={formik.values.cropID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('cropID')}
                                            error={Boolean(touched.cropID && errors.cropID)}
                                            helperText={touched.cropID && errors.cropID}
                                        >
                                            <MenuItem key={0} value={0}> Select Crop</MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.productID} value={option.productID}>
                                                    {option.productName}
                                                </MenuItem>
                                            ))}
                                        </TextField> : null}
                                </Stack>
                            </Stack>
                            <br />
                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color='error'
                                    onClick={() => clearAll()}
                                > Clear</Button>
                                <Button
                                    type="submit"
                                    color='secondary'
                                    variant="outlined"
                                >Search</Button>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br /><Divider variant="middle" /><br />
                    {farmerwiseList.length != 0 ?
                        <Card style={{ justifycontent: 'center', width: '72rem' }}>
                            <Paper className={classes.root}>
                                <TableContainer component={Paper}>
                                    <Table aria-label="collapsible table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Product Name</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Demanded Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Supplied Quantity</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {farmerwiseList.map((row, index) => (
                                                < TableRow key={index} row={row} >
                                                    <TableCell component="th" scope="row">
                                                        {row.productName}
                                                    </TableCell>
                                                    <TableCell >{row.date}</TableCell>
                                                    <TableCell >{row.demandedQuantity}</TableCell>
                                                    <TableCell >{row.suppliedQuantity}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Card> :
                        cropwiseList.length != 0 ?
                            <Card style={{ justifycontent: 'center', width: '72rem' }}>
                                <Paper className={classes.root}>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="collapsible table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Farmer Name</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Demanded Quantity</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Supplied Quantity</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {cropwiseList.map((row, index) => (
                                                    < TableRow key={index} row={row} >
                                                        <TableCell component="th" scope="row">
                                                            {row.firstName}
                                                        </TableCell>
                                                        <TableCell >{row.date}</TableCell>
                                                        <TableCell >{row.demandedQuantity}</TableCell>
                                                        <TableCell >{row.suppliedQuantity}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Card> : null}
                    {cropwiseList.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" paddingTop={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFileCropwise()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Outlet Product Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    List={cropwiseList}
                                    searchData={selectedSearchValuesCropwise}
                                />
                            </div>
                        </Box> : null}
                    {farmerwiseList.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" paddingTop={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFileFarmerwise()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Outlet Product Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    List={farmerwiseList}
                                    searchData={selectedSearchValuesFarmerwise}
                                />
                            </div>
                        </Box>
                        : null}
                </Container>
            </Page>
        </>
    );
}